import React, { useEffect, useState, useMemo } from "react";
import { Trash2, Edit, Search } from "lucide-react";
import axios from "axios";
import Apiurl from "../../environment/Apiurl";

function Doctorfees() {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showEntries, setShowEntries] = useState("10");
  const [doctor, setDoctor] = useState([]);
  const [userPrivileges, setUserPrivileges] = useState({});
  const [loadingPrivileges, setLoadingPrivileges] = useState(true);

  // Form state for adding
  const [addData, setAddData] = useState({
    type: "",
    doctor_id: "",
    charge_per_treatment: "",
    maximum_discount_percentage: "",
  });

  // Form state for editing
  const [updateData, setUpdateData] = useState({
    type: "",
    doctor_id: "",
    charge_per_treatment: "",
    maximum_discount_percentage: "",
  });

  // Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [editingId, setEditingId] = useState(null);

  // Fetch user privileges based on role_id
  const fetchUserPrivileges = async () => {
    try {
      setLoadingPrivileges(true);
      const userRoleId = localStorage.getItem("role_id") || "unknown";
      console.log("Fetching privileges for role_id:", userRoleId);

      if (userRoleId === "unknown") {
        console.warn("No role_id found in localStorage");
        setError(
          "No role assigned to the user. Please contact the administrator."
        );
        setTimeout(() => setError(null), 3000);
        return;
      }

      const response = await axios.get(`${Apiurl}/roles_and_privillage`);
      console.log("Fetched roles data:", response.data);

      if (!response.data || !Array.isArray(response.data)) {
        throw new Error("Invalid or empty roles data received");
      }

      const roleData = response.data.find(
        (role) => role.role_id === userRoleId
      );

      if (roleData) {
        console.log("Found role data for role_id:", userRoleId, roleData);
        const privileges = {};
        roleData.pages.forEach((page) => {
          const pageName = page.page; // Use exact page name
          const pagePrivileges = page.priviallages || page.privileges || {};
          privileges[pageName] = {
            access: page.access,
            ...pagePrivileges,
          };
        });
        console.log("Set user privileges:", privileges);
        setUserPrivileges(privileges);
      } else {
        console.warn("No role data found for role_id:", userRoleId);
        setError("No role data found for the current user.");
        setTimeout(() => setError(null), 3000);
      }
    } catch (error) {
      console.error(
        "Error fetching user privileges:",
        error.message,
        error.response?.data
      );
      setError("Failed to fetch user privileges. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoadingPrivileges(false);
    }
  };


      useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  // Check if user has specific permission for Doctor Fee Master page
  const hasPermission = (permission) => {
    const doctorFeePrivileges = userPrivileges["Doctor Fee Master"];
    if (!doctorFeePrivileges) {
      console.log("No privileges found for Doctor Fee Master page");
      return false;
    }
    console.log(
      `Checking permission '${permission}' for Doctor Fee Master:`,
      doctorFeePrivileges
    );
    if (doctorFeePrivileges.all) return true;
    const hasPerm = doctorFeePrivileges[permission] || false;
    console.log(`Permission '${permission}' result:`, hasPerm);
    return hasPerm;
  };


  
// Fetch data from API
const fetchData = async () => {
  if (!hasPermission("read")) {
    console.warn("Read permission denied for Doctor Fee Master page");
    setError("You do not have permission to view doctor fees.");
    setTimeout(() => setError(null), 3000);
    return;
  }

  setLoading(true);
  try {
    const response = await axios.get(`${Apiurl}/doctor_fee_master`);
    console.log("Fetched doctor fees data:", response.data);
    
    // Reverse the data before setting it to state
    const reversedData = (response.data || []).reverse();
    setResponseData(reversedData);

    setError(null);
  } catch (error) {
    console.error(
      "Error fetching doctor fees:",
      error.message,
      error.response?.data
    );
    setError("Failed to fetch doctor fees. Please try again.");
    setResponseData([]);
    setTimeout(() => setError(null), 3000);
  } finally {
    setLoading(false);
  }
};


  // Fetch doctor details
  const fetchDoctor = async () => {
    try {
      const response = await axios.get(`${Apiurl}/doctor`);
      console.log("Fetched doctor details:", response.data);
      setDoctor(response.data || []);
    } catch (error) {
      console.error(
        "Error fetching doctor details:",
        error.message,
        error.response?.data
      );
      setError("Failed to fetch doctor details. Please try again.");
      setTimeout(() => setError(null), 3000);
    }
  };

  useEffect(() => {
    console.log("Fetching initial data...");
    fetchUserPrivileges();
  }, []);

  useEffect(() => {
    if (hasPermission("read")) {
      console.log(
        "Fetching doctor fees and doctor details due to read permission"
      );
      fetchData();
      fetchDoctor();
    } else if (!loadingPrivileges) {
      console.warn("Read permission denied for Doctor Fee Master page");
      setError("You do not have permission to view doctor fees.");
      setTimeout(() => setError(null), 3000);
    }
  }, [userPrivileges, loadingPrivileges]);

  // Reset current page on search or items per page change
  useEffect(() => {
    console.log(
      "Resetting current page due to searchTerm or itemsPerPage change"
    );
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  // Handle input changes for add form
  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Add form input changed: ${name} = ${value}`);
    setAddData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle input changes for edit form
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Edit form input changed: ${name} = ${value}`);
    setUpdateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form data
  const validateForm = (data) => {
    if (!data.type) return "Type is required.";
    if (!data.doctor_id) return "Doctor ID is required.";
    if (!data.charge_per_treatment) return "Charge per treatment is required.";
    if (!data.maximum_discount_percentage)
      return "Maximum discount percentage is required.";
    const charge = Number(data.charge_per_treatment);
    const discount = Number(data.maximum_discount_percentage);
    if (isNaN(charge) || charge <= 0)
      return "Charge per treatment must be a positive number.";
    if (isNaN(discount) || discount < 0 || discount > 100)
      return "Maximum discount percentage must be between 0 and 100.";
    return null;
  };

  // Handle add form submission
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission("create")) {
      console.warn("Create permission denied for Doctor Fee Master page");
      setError("You do not have permission to add doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    const validationError = validateForm(addData);
    if (validationError) {
      console.warn("Validation error:", validationError);
      setError(validationError);
      setTimeout(() => setError(null), 3000);
      return;
    }
    setLoading(true);
    try {
      const formData = {
        type: addData.type,
        doctor_id: addData.doctor_id,
        charge_per_treatment: Number(addData.charge_per_treatment),
        maximum_discount_percentage: Number(
          addData.maximum_discount_percentage
        ),
      };
      console.log("Adding doctor fee with data:", formData);
      await axios.post(`${Apiurl}/doctor_fee_master`, formData);
      fetchData();
      closeAddModal();
    } catch (error) {
      console.error(
        "Error adding doctor fee:",
        error.message,
        error.response?.data
      );
      setError("Failed to add doctor fee. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoading(false);
    }
  };

  // Handle edit form submission
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission("update")) {
      console.warn("Update permission denied for Doctor Fee Master page");
      setError("You do not have permission to edit doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (!editingId) {
      console.warn("Invalid doctor fee ID:", editingId);
      setError("Invalid doctor fee ID.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    const validationError = validateForm(updateData);
    if (validationError) {
      console.warn("Validation error:", validationError);
      setError(validationError);
      setTimeout(() => setError(null), 3000);
      return;
    }
    setLoading(true);
    try {
      const formData = {
        type: updateData.type,
        doctor_id: updateData.doctor_id,
        charge_per_treatment: Number(updateData.charge_per_treatment),
        maximum_discount_percentage: Number(
          updateData.maximum_discount_percentage
        ),
      };
      console.log("Updating doctor fee with ID:", editingId, "Data:", formData);
      await axios.put(`${Apiurl}/doctor_fee_master/${editingId}`, formData);
      fetchData();
      closeEditModal();
    } catch (error) {
      console.error(
        "Error updating doctor fee:",
        error.message,
        error.response?.data
      );
      setError("Failed to update doctor fee. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoading(false);
    }
  };

  // Reset add form
  const resetAddForm = () => {
    console.log("Resetting add form");
    setAddData({
      type: "",
      doctor_id: "",
      charge_per_treatment: "",
      maximum_discount_percentage: "",
    });
  };

  // Edit doctor fee
  const handleEdit = (id, fee) => {
    if (!hasPermission("update")) {
      console.warn("Update permission denied for Doctor Fee Master page");
      setError("You do not have permission to edit doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (!id) {
      console.warn("Invalid doctor fee ID:", id);
      setError("Invalid doctor fee ID.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Opening Edit Doctor Fee modal for ID:", id, "Fee:", fee);
    setEditingId(id);
    setUpdateData({
      type: fee.type || "",
      doctor_id: fee.doctor_id || "",
      charge_per_treatment: fee.charge_per_treatment || "",
      maximum_discount_percentage: fee.maximum_discount_percentage || "",
    });
    setShowEditModal(true);
  };

  // Open delete confirmation modal
  const openDeleteModal = (id) => {
    if (!hasPermission("delete")) {
      console.warn("Delete permission denied for Doctor Fee Master page");
      setError("You do not have permission to delete doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (!id) {
      console.warn("Invalid doctor fee ID:", id);
      setError("Invalid doctor fee ID.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Opening Delete Doctor Fee modal for ID:", id);
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Close delete confirmation modal
  const closeDeleteModal = () => {
    console.log("Closing Delete Doctor Fee modal");
    setShowDeleteModal(false);
    setDeleteId(null);
    setError(null);
  };

  // Handle delete doctor fee
  const confirmDelete = async () => {
    if (!hasPermission("delete")) {
      console.warn("Delete permission denied for Doctor Fee Master page");
      setError("You do not have permission to delete doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (!deleteId) {
      console.warn("Invalid doctor fee ID:", deleteId);
      setError("Invalid doctor fee ID.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    setLoading(true);
    try {
      console.log("Deleting doctor fee with ID:", deleteId);
      await axios.delete(`${Apiurl}/doctor_fee_master/${deleteId}`);
      fetchData();
      closeDeleteModal();
    } catch (error) {
      console.error(
        "Error deleting doctor fee:",
        error.message,
        error.response?.data
      );
      setError("Failed to delete doctor fee. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoading(false);
    }
  };

  // Modal handlers
  const openAddModal = () => {
    if (!hasPermission("create")) {
      console.warn("Create permission denied for Doctor Fee Master page");
      setError("You do not have permission to add doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Opening Add Doctor Fee modal");
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    if (!hasPermission("create")) {
      console.warn("Create permission denied for Doctor Fee Master page");
      setError("You do not have permission to add doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Closing Add Doctor Fee modal");
    setShowAddModal(false);
    resetAddForm();
    setError(null);
  };

  const closeEditModal = () => {
    if (!hasPermission("update")) {
      console.warn("Update permission denied for Doctor Fee Master page");
      setError("You do not have permission to edit doctor fees.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Closing Edit Doctor Fee modal");
    setShowEditModal(false);
    setEditingId(null);
    setUpdateData({
      type: "",
      doctor_id: "",
      charge_per_treatment: "",
      maximum_discount_percentage: "",
    });
    setError(null);
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    const result = responseData.filter((item) => {
      const doctorName =
        item.doctor_details?.[0]?.doctor_name?.toString() || "";
      return [
        item.type,
        item.doctor_id?.toString(),
        item.charge_per_treatment?.toString(),
        item.maximum_discount_percentage?.toString(),
        doctorName,
      ].some((field) =>
        field?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
    console.log("Filtered data:", result);
    return result;
  }, [responseData, searchTerm]);

  // Update items per page
  useEffect(() => {
    console.log("Updating items per page to:", showEntries);
    if (showEntries === "All") {
      setItemsPerPage(filteredData.length || 1);
    } else {
      setItemsPerPage(Number(showEntries));
    }
  }, [showEntries, filteredData]);

  // Calculate pagination values
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  console.log(
    "Pagination - totalPages:",
    totalPages,
    "itemsPerPage:",
    itemsPerPage,
    "filteredData.length:",
    filteredData.length
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  console.log(
    "Current items:",
    currentItems,
    "from index",
    indexOfFirstItem,
    "to",
    indexOfLastItem
  );

  // Generate page list for pagination
  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    console.log("Generated page list:", pages);
    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      console.log("Navigating to page:", page);
      setCurrentPage(page);
    }
  };

  if (loadingPrivileges) {
    return <div className="text-center py-5">Loading permissions...</div>;
  }

  if (!hasPermission("access")) {
    console.log(
      "Access denied for role_id:",
      localStorage.getItem("role_id"),
      "on Doctor Fee Master page"
    );
    return (
      <div className="p-3">
        <div className="alert alert-danger">
          You don't have permission to access this page.
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <style>{`
        .btn-custom { 
          background-color: #01AEBE; 
          color: white; 
          border: none;
        }
        .btn-custom:hover { 
          background-color: #018A97; 
          color: white;
        }
      `}</style>

      {hasPermission("create") && (
        <div className="text-end">
          <button className="btn btn-custom btn-sm" onClick={openAddModal}>
            <i className="fas fa-plus me-2"></i> Add Doctor Fee
          </button>
        </div>
      )}

      {error && (
        <div className="alert alert-danger alert-dismissible fade show mt-2">
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      {hasPermission("read") && (
        <div className="card card-body mt-2">
          <div className="bg-white rounded shadow-sm">
            <div className="row mb-3 crm-table-toolbar">
              <div className="col-md-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-table"></i>
                  </span>
                  <select
                    className="form-select"
                    value={showEntries}
                    onChange={(e) => {
                      console.log(
                        "Changing items per page to:",
                        e.target.value
                      );
                      setShowEntries(e.target.value);
                    }}
                  >
                    <option value="All">Show All</option>
                    {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
                      <option key={n} value={n}>
                        Show {n}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-7"></div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pe-5"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => {
                        console.log("Search term changed to:", e.target.value);
                        setSearchTerm(e.target.value);
                      }}
                      style={{ width: "250px", paddingRight: "2.5rem" }}
                    />
                    <Search
                      size={16}
                      className="position-absolute text-muted"
                      style={{
                        right: "10px",
                        top: "35%",
                        transform: "translateY(-50%)",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {loading && <div className="text-center py-3">Loading...</div>}

            <div className="table-responsive">
              <table className="table table-hover">
                <thead style={{ backgroundColor: "#01AEBE", color: "white" }}>
                  <tr>
                    <th>S.No</th>
                    <th>Type</th>
                    <th>Doctor ID</th>
                    <th>Doctor Name</th>
                    <th>Charge per Treatment</th>
                    <th>Max Discount (%)</th>
                    {(hasPermission("update") || hasPermission("delete")) && (
                      <th>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((fee, index) => (
                      <tr key={fee._id || index} className="align-middle">
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{fee.type || "-"}</td>
                        <td>{fee.doctor_id || "-"} </td>

                        <td>{fee.doctor_details?.[0]?.doctor_name || "-"}</td>

                        <td>{fee.charge_per_treatment || "-"}</td>
                        <td>{fee.maximum_discount_percentage || "-"}</td>
                        {(hasPermission("update") ||
                          hasPermission("delete")) && (
                          <td>
                            {hasPermission("delete") && (
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => openDeleteModal(fee._id)}
                              >
                                <Trash2 size={16} className="text-danger" />
                              </button>
                            )}
                            {hasPermission("update") && (
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => handleEdit(fee._id, fee)}
                              >
                                <Edit size={16} className="text-primary" />
                              </button>
                            )}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={
                          hasPermission("update") || hasPermission("delete")
                            ? 6
                            : 5
                        }
                        className="text-center py-4"
                      >
                        {loading ? (
                          "Loading..."
                        ) : (
                          <div className="text-muted">
                            <i className="fas fa-search fa-2x mb-2"></i>
                            <br />
                            No doctor fees found matching your search criteria
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="container">
              <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage > 1 && handlePageClick(currentPage - 1)
                  }
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span className="d-none d-sm-inline">Previous</span>
                </button>

                <div
                  className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                  style={{ maxWidth: "100%" }}
                >
                  {pages.map((page, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm px-3 flex-shrink-0 ${
                        page === currentPage
                          ? "text-white"
                          : "btn-outline-secondary"
                      }`}
                      style={
                        page === currentPage
                          ? { backgroundColor: "#20c997", border: "none" }
                          : {}
                      }
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage < totalPages && handlePageClick(currentPage + 1)
                  }
                  disabled={currentPage === totalPages}
                >
                  <span className="d-none d-sm-inline">Next</span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Doctor Fee Modal */}
      {hasPermission("create") && (
        <div
          className={`modal fade ${showAddModal ? "show" : ""}`}
          style={{ display: showAddModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addDoctorFeeModalLabel"
          aria-hidden={!showAddModal}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h6
                  className="modal-title text-dark"
                  id="addDoctorFeeModalLabel"
                >
                  Add Doctor Fee
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeAddModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="type" className="form-label fw-bold">
                          Type
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="type"
                          name="type"
                          placeholder="Enter Type (e.g., IVF)"
                          value={addData.type}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="doctor_id"
                          className="form-label fw-bold"
                        >
                          Doctor ID
                        </label>
                        <select
                          className="form-control form-control-sm"
                          name="doctor_id"
                          value={addData.doctor_id}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Doctor ID</option>
                          {doctor.map((doc, index) => (
                            <option key={index} value={doc.doctor_id}>
                              {doc.doctor_id} - {doc.doctor_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="charge_per_treatment"
                          className="form-label fw-bold"
                        >
                          Charge per Treatment
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="charge_per_treatment"
                          name="charge_per_treatment"
                          placeholder="Enter Charge"
                          value={addData.charge_per_treatment}
                          onChange={handleAddInputChange}
                          min="0"
                          step="0.01"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="maximum_discount_percentage"
                          className="form-label fw-bold"
                        >
                          Max Discount (%)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="maximum_discount_percentage"
                          name="maximum_discount_percentage"
                          placeholder="Enter Max Discount"
                          value={addData.maximum_discount_percentage}
                          onChange={handleAddInputChange}
                          min="0"
                          max="100"
                          step="0.01"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-sm px-3 me-2"
                      style={{ backgroundColor: "#e0e0e0", color: "#333" }}
                      onClick={closeAddModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-custom btn-sm px-4"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Doctor Fee Modal */}
      {hasPermission("update") && (
        <div
          className={`modal fade ${showEditModal ? "show" : ""}`}
          style={{ display: showEditModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="editDoctorFeeModalLabel"
          aria-hidden={!showEditModal}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h6
                  className="modal-title text-dark"
                  id="editDoctorFeeModalLabel"
                >
                  Edit Doctor Fee
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeEditModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="type" className="form-label fw-bold">
                          Type
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="type"
                          name="type"
                          placeholder="Enter Type (e.g., IVF)"
                          value={updateData.type}
                          onChange={handleEditInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="doctor_id"
                          className="form-label fw-bold"
                        >
                          Doctor ID
                        </label>
                        <select
                          className="form-control form-control-sm"
                          name="doctor_id"
                          value={updateData.doctor_id}
                          onChange={handleEditInputChange}
                          required
                        >
                          <option value="">Select Doctor ID</option>
                          {doctor.map((doc, index) => (
                            <option key={index} value={doc.doctor_id}>
                              {doc.doctor_id} - {doc.doctor_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="charge_per_treatment"
                          className="form-label fw-bold"
                        >
                          Charge per Treatment
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="charge_per_treatment"
                          name="charge_per_treatment"
                          placeholder="Enter Charge"
                          value={updateData.charge_per_treatment}
                          onChange={handleEditInputChange}
                          min="0"
                          step="0.01"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="maximum_discount_percentage"
                          className="form-label fw-bold"
                        >
                          Max Discount (%)
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="maximum_discount_percentage"
                          name="maximum_discount_percentage"
                          placeholder="Enter Max Discount"
                          value={updateData.maximum_discount_percentage}
                          onChange={handleEditInputChange}
                          min="0"
                          max="100"
                          step="0.01"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-sm px-3 me-2"
                      style={{ backgroundColor: "#e0e0e0", color: "#333" }}
                      onClick={closeEditModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-custom btn-sm px-4"
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {hasPermission("delete") && (
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="deleteDoctorFeeModalLabel"
          aria-hidden={!showDeleteModal}
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeDeleteModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <div style={{ marginBottom: "15px" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "50%",
                      textAlign: "center",
                      lineHeight: "40px",
                    }}
                  >
                    <i
                      className="fas fa-exclamation-triangle"
                      style={{ color: "#dc2626", fontSize: "20px" }}
                    ></i>
                  </span>
                </div>
                <h5 className="modal-title" id="deleteDoctorFeeModalLabel">
                  Delete Doctor Fee
                </h5>
                <p style={{ marginTop: "10px" }}>
                  Are you sure you want to delete this doctor fee?
                </p>
              </div>
              <div
                className="modal-footer"
                style={{ borderTop: "none", justifyContent: "center" }}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#e0e0e0",
                    color: "#333",
                  }}
                  onClick={closeDeleteModal}
                >
                  No, Keep it
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={confirmDelete}
                  disabled={loading}
                >
                  {loading ? "Deleting..." : "Yes, Delete It!"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {(showAddModal || showEditModal || showDeleteModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
}

export default Doctorfees;
